import { Outlet, Navigate } from "react-router-dom";
import Parse from "parse";


export default function ProtectedRoutes() {
  const user = Parse.User.current() != null
  return user ? <Outlet /> : <Navigate to="/login" />
}
